import React, { useState, useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import { useHistory } from 'react-router'
import ServerError from '../../../../lib/components/ServerError'
import {caselessPaymentSuccesslUrl, CASELESS_SEARCH} from '../../../routing/paths'
import StoreContext from '../../../providers/storesContext'
import Button from '../../../components/Button'
import TermsAndConditions from '../../../components/Checkout/TermsAndConditions'
import CaselessInvoiceSummary from '../components/CaselessInvoiceSummary'
import CaselessCheckoutCreditCardStore from './CaselessCheckoutCreditCardStore'
import BasicForm from '../../../components/Checkout/BasicForm'
import { topBarStore } from '../../../../lib/stores/TopBarStore'
import Spinner from '../../../components/Spinner'
import SpreedlyCreditCardInputs from "../../../components/Checkout/SpreedlyCreditCardInputs";
import config from '../../../../lib/config'


const CaselessCheckoutCreditCard = () => {
  const history = useHistory()
  const { licenseStore } = useContext(StoreContext)
  const [caselessCheckoutCreditCardStore] = useState(
    () => new CaselessCheckoutCreditCardStore(licenseStore)
  )

  const { license } = licenseStore

  const handleSubmit = () => {
    const requiredFields = []
    requiredFields['first_name'] = caselessCheckoutCreditCardStore.firstName.value
    requiredFields['last_name'] = caselessCheckoutCreditCardStore.lastName.value
    requiredFields['address1'] = caselessCheckoutCreditCardStore.addressLine.value
    requiredFields['city'] = caselessCheckoutCreditCardStore.city.value
    requiredFields['state'] = caselessCheckoutCreditCardStore.state.value
    requiredFields['zip'] = caselessCheckoutCreditCardStore.zipCode.value
    requiredFields['country'] = caselessCheckoutCreditCardStore.country.value
    requiredFields['phone_number'] = caselessCheckoutCreditCardStore.phone.value
    requiredFields['email'] = caselessCheckoutCreditCardStore.email.value
    requiredFields['month'] = caselessCheckoutCreditCardStore.month.value
    requiredFields['year'] = caselessCheckoutCreditCardStore.year.value

    Spreedly.tokenizeCreditCard(requiredFields);
  }
  const handleToggleTerms = () => caselessCheckoutCreditCardStore.toggleTerms()

  const { agreedTerms, isLoading, globalError, termsError, usaeError } =
    caselessCheckoutCreditCardStore

  useEffect(async () => {
    topBarStore.setTitle('Checkout')
    // TODO: chequear que hace este if
    if (!licenseStore.license) {
      const licenseNumber = new URLSearchParams(location.search).get('license_number')
      const licenseState = new URLSearchParams(location.search).get('license_state')
      const operationId = new URLSearchParams(location.search).get('operation_id')

      if (licenseNumber && licenseState && operationId) {
        await licenseStore.loadCaselessByLicense(licenseNumber, licenseState, operationId)
      } else {
        history.push(CASELESS_SEARCH)
      }
    }

    // Spreedly is defined in the iframe, in drivers.blade.php
    if (typeof Spreedly !== 'undefined') {
      // environment_key
      Spreedly.init(config.SPREEDLY_ENVIRONMENT_KEY, {
        "numberEl": "spreedly-number",
        "cvvEl": "spreedly-cvv"
      });

      Spreedly.on('ready', function() {
        // TODO: enable submit when loaded.
        // var submitButton = document.getElementById('submit-button');
        // submitButton.disabled = false;

        Spreedly.setTitle("number", "credit card");
        Spreedly.setStyle("number", "font-size: 16px; width: 310px; line-height:25px;");
        Spreedly.setTitle("cvv", "cvv");
        Spreedly.setStyle("cvv", "font-size: 16px; width: 310px; line-height:25px;");
        Spreedly.setFieldType("number", "tel");
        Spreedly.setNumberFormat("prettyFormat");
      });

      // TODO: errors in front.
      Spreedly.on('errors', function(errors) {
        caselessCheckoutCreditCardStore.validate()
        for (var i=0; i < errors.length; i++) {
          const error = errors[i];
          if (error.attribute == 'month' || error.attribute == 'year') {
            caselessCheckoutCreditCardStore.globalError = 'Card expiration date is invalid.';
            return
          }
          if (error.attribute == 'number') {
            caselessCheckoutCreditCardStore.globalError = error.message;
            return
          }

          console.log('error', error.message)
        };
      });

      Spreedly.on('paymentMethod', async function(spreedlyToken, pmData) {
        caselessCheckoutCreditCardStore.setPaymentMethodToken(spreedlyToken)
        const token = await getRecaptchaToken();
        const result = await caselessCheckoutCreditCardStore.checkout(token)
        if (result !== false) {
          history.push(caselessPaymentSuccesslUrl(licenseStore.operationId))
        }
      });
    } else {
      console.error('Spreedly iframe is not loaded')
    }
  }, [])

  const getRecaptchaToken = async() => {
    if(!config.GOOGLE_RECAPTCHA_ENABLED){
      return null;
    }
    
   const result =  await new Promise((res, rej) => {
    window.grecaptcha.ready(() => window.grecaptcha.execute(config.GOOGLE_RECAPTCHA_SITE_KEY, { action: 'submit' }).then(
      (token) => res(token),
    ))
  })

    return result;
  }

  if (licenseStore.isLoading) {
    return <Spinner />
  }

  return (
    <div>
      {licenseStore.license && (
        <>
          <BasicForm checkoutStore={caselessCheckoutCreditCardStore} />
          <SpreedlyCreditCardInputs checkoutStore={caselessCheckoutCreditCardStore}/>
          {usaeError && <ServerError message={usaeError} />}
          <TermsAndConditions handleToggleTerms={handleToggleTerms} agreedTerms={agreedTerms} />
          {termsError && <ServerError message="You must accept the terms and conditions" />}
          <CaselessInvoiceSummary bill={license.bill} />
          {globalError !== '' && <ServerError message={globalError} />}
          <div>
            <Button extraStyle="w-full mb-8 mt-4" onClick={handleSubmit} isLoading={isLoading}>
              Submit
            </Button>
          </div>
        </>
      )}
      {licenseStore.serverError && <ServerError message={licenseStore.serverError} />}
    </div>
  )
}

export default observer(CaselessCheckoutCreditCard)
